import { Component, OnInit, ViewChild, ElementRef, ChangeDetectorRef, HostListener } from '@angular/core';
import { Approved, Sub, Specification, Remark, sendEmailmultiple } from 'src/app/service/modal/approved';
import { ApprovedService } from 'src/app/service/apiservice/approved.service';
import { PendingRequestService } from 'src/app/service/apiservice/pendingrequest.service';
import { CookieService } from 'ngx-cookie-service';
import { UtilFunctions } from '../../../util-functions';
import { Globals } from '../../../globals';
import { UploadFileS3BucketService } from '../../../service/apiservice/uploadFileS3Bucket.service';
import { DatePipe } from '@angular/common';
import { Attachment } from '../../../service/modal/pendingrequest';
import { AttachmentService } from '../../../service/apiservice/attachmet.service';
import { DataService } from '../../../service/apiservice/data.service';
import { Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { NgSelectComponent } from '@ng-select/ng-select';
// dropdown list
import { DataManager, Query } from '@syncfusion/ej2-data';
// import { Query } from '@syncfusion/ej2-data';
import { EmitType } from '@syncfusion/ej2-base';
import { FilteringEventArgs } from '@syncfusion/ej2-dropdowns';
import { NgForm, FormBuilder, Validators, AbstractControl, FormControl, FormGroup } from '@angular/forms';

declare var $;
declare function info_noti(msg: any): any;
@Component({
  selector: 'app-approved-hc',
  templateUrl: './approved-hc.component.html',
  styleUrls: ['./approved-hc.component.css']
})
export class ApprovedHcComponent implements OnInit {

  approvedGrid: Approved[] = new Array();
  approvedViewData: Approved = new Approved();
  addApprovedHealthCard: Approved = new Approved();
  submitted: boolean = false;
  showActions: boolean = false;
  newline: string = '/n';
  @ViewChild('addForm') addForm: any;
  @ViewChild('AddCloseForm') addCloseForm: ElementRef;
  @ViewChild('AttachmentCloseForm') attachment_CloseForm: ElementRef;
  eyeIcon: string = "zmdi-eye-off";
  starIcon: string = "zmdi-star-outline";
  eyeIconViewData: string = "zmdi-eye-off";
  starIconViewData: string = "zmdi-star-outline";
  //subject DropDown//
  subjectDropDown: any;
  subjectDropDown_SelectedId: number[];
  //subject DropDown//

  //Specification DropDown//
  specificationDropDown: any;
  specificationDropDown_SelectedId: number[];
  //Specification DropDown//

  //Remark DropDown//
  remarkDropDown: any;
  remarkDropDown_SelectedId: number[];
  //Remark DropDown//
  todayDate: any;
  selectedMailList = [];


  selectedActionList: Approved[] = new Array();
  appvar: Approved;
  attachmentFile: File;
  approvedObjActionShow = new Approved();
  checkClickCount = 0;
  selectedFiles: File[];
  attchmentList: Attachment[] = new Array();
  attachdata = new Attachment();
  url;
  approvedAttachmentData: any;
  approvedAttachmentDataShow: any;
  image: boolean = false;
  sendEmailmultiple = new sendEmailmultiple;
  subdata: string = '';
  hoveredIndex;
  emailId;

  uploadfile: boolean = false;
  // selectedFileNames='';
  @ViewChild('selectedFileNames') selectedFileNames: ElementRef;
  @ViewChild('subjectId') subjectId: NgSelectComponent;
  @ViewChild('remarkId') remarkId: NgSelectComponent;
  @ViewChild('specificationId') specificationId: NgSelectComponent;

  senderNameDropDown: any;

  constructor(private fb: FormBuilder,private spinner: NgxSpinnerService, private router: Router, private uploadService: UploadFileS3BucketService, private _approvedService: ApprovedService,
    private _pendingRequestService: PendingRequestService,
    private chRef: ChangeDetectorRef, private global: Globals, private datePipe: DatePipe, private _attachmentService: AttachmentService, private data: DataService) { }
  todate;
  ngOnInit() {
    localStorage.setItem("Active Route", this.router.url);
    this.global.afterRefreshPageSetToken();
    this.GetApproved_Grid();

    this.addApprovedHealthCard.hide = false;
    this.addApprovedHealthCard.star = false;
    this.todayDate = new Date();

    // var tzoffset = (new Date()).getTimezoneOffset() * 60000; //offset in milliseconds
    // var localISOTime = (new Date(Date.now() - tzoffset)).toISOString().slice(0, -1);
    // var changedate = this.datePipe.transform(localISOTime, 'yyyy-MM-ddTHH:mm');
    // this.addApprovedHealthCard.dateTime = changedate;

    $(".modal-wide").on("show.bs.modal", function () {
      var height = $(window).height() - 80;
      $(this).find(".modal-body").css("max-height", height);
    });
    this.getSecification();
    this.loadSendEmailForm();
    // this.todayDate
  }

  checkYear(data): Boolean {
    let userDate = new Date(data);
    if (userDate.getFullYear() == this.todayDate.getFullYear()) {
      return true;
    }
    else {
      return false;
    }
  }



  GetApproved_Grid() {
    // this.spinner.show();
    this._approvedService.GetApprovedList()
      .subscribe((response) => {
        if ($.fn.dataTable.isDataTable('#approvedDatatableTest')) {
          $('#approvedDatatableTest').dataTable().fnClearTable();
          $('#approvedDatatableTest').dataTable().fnDestroy();
        }

        if ($.fn.dataTable.isDataTable('#approvedDatatable_IsMobile')) {
          $('#approvedDatatable_IsMobile').dataTable().fnClearTable();
          $('#approvedDatatable_IsMobile').dataTable().fnDestroy();
        }
        // this.spinner.hide();
        console.log(this.approvedGrid);
        Object.assign(this.approvedGrid, response);
        this.approvedGrid.forEach((element) => {

          if (element.sub.length == 0) {
            element.subBindGrid = "";
          } else {
            element.sub.forEach((elem) => {
              if (element.subBindGrid == undefined) {
                element.subBindGrid = elem.name
              }
              else {
                element.subBindGrid = element.subBindGrid + ',' + elem.name;
              }
              // element.subBindGrid="";
            })
          }
          if (element.spec.length == 0) {
            element.specBindGrid = "";
          } else {
            element.spec.forEach((elem) => {
              if (element.specBindGrid == undefined) { element.specBindGrid = elem.name }
              else { element.specBindGrid = element.specBindGrid + ',' + elem.name; }
            })
          }
          if (element.remark.length == 0) {
            element.remarkBindGrid = "";
          } else {
            element.remark.forEach((elem) => {
              if (element.remarkBindGrid == undefined) { element.remarkBindGrid = elem.name }
              else { element.remarkBindGrid = element.remarkBindGrid + ',' + elem.name; }
            })
          }
        });
        this.chRef.detectChanges();
        // $.fn.dataTable.moment('DD/MM/YY');
        $('#approvedDatatableTest').DataTable({
          "paging": false,
          "info": false,
          'columnDefs': [{ 'orderable': false, 'targets': 0 }],
          "order": [[8, 'desc']],
          dom: 'Bfrtip',
          buttons: [
            { extend: 'pdf', title: 'Approved Pdf', attr: { id: "pdfBtn" }, exportOptions: { columns: [2, 3, 4, 5, 6, 7, 9] } },
            { extend: 'excel', title: 'Approved Excel', attr: { id: "excelBtn" }, exportOptions: { columns: [2, 3, 4, 5, 6, 7, 9] } }
          ],
          "fnDrawCallback": function () {
            var table = $('#approvedDatatableTest').DataTable();
            $(table.buttons('.buttons-pdf').nodes()).css("display", "none");
            $(table.buttons('.buttons-excel').nodes()).css("display", "none");
          }
        });
        $("#approvedDatatableTest_filter").hide();

        $("#approvedDatatable_IsMobile").DataTable({
          "paging": false,
          "info": false,
          "order": [[3, 'desc']],
          'columnDefs': [{ 'orderable': false, 'targets': 0 }],
          dom: 'Bfrtip',
          buttons: [
            { extend: 'pdf', title: 'Approved Pdf', attr: { id: "pdfBtnIsMobile" }, exportOptions: { columns: [2, 4] } },
            { extend: 'excel', title: 'Approved Excel', attr: { id: "excelBtnIsMobile" }, exportOptions: { columns: [2, 4] } }
          ],
          "fnDrawCallback": function () {
            var table = $('#approvedDatatable_IsMobile').DataTable();
            $(table.buttons('.buttons-pdf').nodes()).css("display", "none");
            $(table.buttons('.buttons-excel').nodes()).css("display", "none");
          }
        });
        $("#approvedDatatable_IsMobile_filter").hide();
      },
        error => {
          console.log(error);
        })
  }

  ExportExcel() {
    $("#excelBtn").click();
  }

  ExportPdf() {
    debugger;
    $("#pdfBtn").click();
  }


  ExportExcel_IsMobile() {
    $("#excelBtnIsMobile").click();
  }

  ExportPdf_IsMobile() {
    $("#pdfBtnIsMobile").click();
  }





  ViewDataBind(data: Approved) {
    if (data.specBindGrid.length > 40) {
      console.log("length is greater");
    } else {
      console.log("length is small");
    }
    Object.assign(this.approvedViewData, data);
    if (this.approvedViewData.hide == true) {
      this.eyeIconViewData = "zmdi-eye";
    } else {
      this.eyeIconViewData = "zmdi-eye-off";
    }
    if (this.approvedViewData.star == true) {
      this.starIconViewData = "zmdi-star";
    } else {
      this.starIconViewData = "zmdi-star-outline";
    }

  }

  //Add approved
  Add_CloseClick() {
    this.addForm.resetForm();
    this.submitted = false;
    $('#file').val('');
    this.selectedFileNames.nativeElement.innerHTML = '';

  }
  getSecification() {
    //Specification Dropdown
    this._pendingRequestService.GetAllSpecification()
      .subscribe((response) => {
        this.specificationDropDown = response;
        console.log(response);
      },
        error => {
          console.log(error);
        })

    //Specification Dropdown
  }
  Add_PreDataBind() {
    this.addApprovedHealthCard = new Approved();
    var tzoffset = (new Date()).getTimezoneOffset() * 60000; //offset in milliseconds
    var localISOTime = (new Date(Date.now() - tzoffset)).toISOString().slice(0, -1);
    var changedate = this.datePipe.transform(localISOTime, 'yyyy-MM-ddTHH:mm');
    this.addApprovedHealthCard.dateTime = changedate;
    this.getSenderName();

    //Subject Dropdown
    this._pendingRequestService.GetAllSubject()
      .subscribe((response) => {
        this.subjectDropDown = response;
        // console.log(response);
      },
        error => {
          console.log(error);
        })

    //Specification Dropdown
    // this._pendingRequestService.GetAllSpecification()
    //   .subscribe((response) => {
    //     this.specificationDropDown = response;
    //     // console.log(response);
    //   },
    //     error => {
    //       console.log(error);
    //     })

    //Specification Dropdown
    this._pendingRequestService.GetAllRemark()
      .subscribe((response) => {
        this.remarkDropDown = response;
        // console.log(response);
      },
        error => {
          console.log(error);
        })
  }

  Eye_Click() {
    this.eyeIcon = this.eyeIcon == "zmdi-eye" ? "zmdi-eye-off" : "zmdi-eye";
    this.addApprovedHealthCard.hide = this.eyeIcon == "zmdi-eye" ? true : false;
  }

  Star_Click() {
    this.starIcon = this.starIcon == "zmdi-star" ? "zmdi-star-outline" : "zmdi-star";
    this.addApprovedHealthCard.star = this.starIcon == "zmdi-star" ? true : false;
  }
  // onFileChange(event){
  //  this.attachmentFile = event.target.files[0];
  //   console.log(event);
  // }

  Attachment_CloseClick() {
    this.attachment_CloseForm.nativeElement.click();

  } NgForm

  ApprovedHealthSubmit(addForm: NgForm) {
    debugger;
    this.submitted = true;
    if (addForm.form.invalid) {

      if (addForm.form.controls.senderId.invalid) {
        $("#senderIdError").html("Sender Name is required")
      } else {
        $("#senderIdError").html("")
      }
      if (addForm.form.controls.subjectDropDown_SelectedId.invalid) {
        $("#subjectIdError").html("Subject Name is required")
      } else {
        $("#subjectIdError").html("")
      }


      // if(addForm.form.controls.senderId.invalid)
      // alert("Sender Name is required");

      //  if(addForm.form.controls.senderId.errors.required){
      //    alert("Sender Name is required");
      //  }

      return;
    }
    //sub data

    // if(this.uploadfile){
    //  if( Globals.attachmentStatus == true){

    var localsub: Sub[] = new Array();
    if (this.subjectDropDown_SelectedId != undefined) {
      for (let data of this.subjectDropDown_SelectedId) {
        if (isNaN(data)) {
          var newSub: Sub = {
            subjectId: 0,
            name: data.toString(),
          }
          localsub.push(newSub);
        }
        else {
          var oldSub: Sub = {
            subjectId: data,
            name: this.subjectDropDown.find(a => a.subjectId == data).name,
          }
          localsub.push(oldSub);
        }
      }
    }
    //spec data
    var localspec: Specification[] = new Array();
    if (this.specificationDropDown_SelectedId != undefined) {
      // this.specificationDropDown_SelectedId.splice(0,1);
      // this.specificationDropDown_SelectedId.splice( this.specificationDropDown_SelectedId.indexOf(0));
      // this.selectedMailList.indexOf(element.appEmailId, 1)
      for (let data of this.specificationDropDown_SelectedId)

        if (isNaN(data)) {
          var newSpec: Specification = {
            specificationId: 0,
            name: data.toString(),
          }
          localspec.push(newSpec);
        }
        else {
          var oldSpec: Specification = {
            specificationId: data,
            name: this.specificationDropDown.find(a => a.specificationId == data).name,
          }
          localspec.push(oldSpec);
        }
    }

    //remark data
    var localrmk: Remark[] = new Array();
    if (this.remarkDropDown_SelectedId != undefined) {
      for (let data of this.remarkDropDown_SelectedId) {
        if (isNaN(data)) {
          var newRmk: Remark = {
            remarkId: 0,
            name: data.toString(),
          }
          localrmk.push(newRmk);
        }
        else {
          var oldRmk: Remark = {
            remarkId: data,
            name: this.remarkDropDown.find(a => a.remarkId == data).name,
          }
          localrmk.push(oldRmk);
        }
      }
    }
    // this.addApprovedHealthCard.file=file;
    this.addApprovedHealthCard.sub = localsub;
    this.addApprovedHealthCard.spec = localspec;
    this.addApprovedHealthCard.remark = localrmk;

    //attachment

    if (this.uploadfile) {
      if (Globals.attachmentStatus == true) {
        var s3path = "https://mdhl.s3.ap-south-1.amazonaws.com/"
        for (var i = 0; i < this.selectedFiles.length; i++) {
          this.attachdata = new Attachment();
          this.attachdata.filePath = s3path + this.global.loggedUser.user.user_reg_id + "/" + this.selectedFiles[i].name;
          this.attachdata.fileSize = this.selectedFiles[i].size;
          this.attachdata.fileType = this.selectedFiles[i].type.split("/")[1];
          this.attachdata.user_id = this.global.loggedUser.user.user_reg_id;
          this.attachdata.fileName = this.selectedFiles[i].name;
          //     this._attachmentService.SaveAttchment(this.attachdata).subscribe((response) => {
          //       this.attachdata.fileId=response.fileId;
          //  info_noti("attachemnt called reponse "+i +" "+this.attachdata.fileId);
          //       console.log("attachment List "+response);
          //     },err=>{

          //     });
          this.attchmentList.push(this.attachdata);
        }

        this.addApprovedHealthCard.attachment = this.attchmentList;
        this._approvedService.AddApproved_HealthCard(this.addApprovedHealthCard)
          .subscribe((response) => {
            this.submitted = false;
            this.spinner.hide();
            this.addForm.resetForm();
            this.addCloseForm.nativeElement.click();
            this.GetApproved_Grid();
            this.selectedFiles = [];
            this.attchmentList = [];
            Globals.attachmentStatus == false;
            this.eyeIcon = "zmdi-eye-off";
            this.starIcon = "zmdi-star-outline";
            this.uploadfile = false;
            $("#file").val('');
            info_noti("HealthCard added successfully");
          },
            error => {
              this.submitted = false;
              info_noti(error);
            })
      } else {
        info_noti("please wait for upload file")
        return false;
      }
    } else {
      this._approvedService.AddApproved_HealthCard(this.addApprovedHealthCard)
        .subscribe((response) => {
          this.submitted = false;
          this.spinner.hide();
          this.addForm.resetForm();
          this.addCloseForm.nativeElement.click();
          this.GetApproved_Grid();
          this.selectedFiles = [];
          this.attchmentList = [];
          Globals.attachmentStatus == false;
          this.eyeIcon = "zmdi-eye-off";
          this.starIcon = "zmdi-star-outline";
          this.uploadfile = false;
          $("#file").val('');
          info_noti("HealthCard added successfully");
        },
          error => {
            this.submitted = false;
            info_noti(error);
          })

    }


    // else {
    //   // return false;
    // }

    // console.log(this.attchmentList);

    //  this.addApprovedHealthCard.attachment= this.global.attachmentList;


  }

  addCancelClick() {
    this.addForm.resetForm();
    $('#file').val('');
    this.selectedFileNames.nativeElement.innerHTML = '';
    this.submitted = false;
  }
  //Add approved


  //DropDown Functions//
  subjectDropDown_Added = (term) => ({ subjectId: term, name: term });
  specificationDropDown_Added = (term) => ({ specificationId: term, name: term });
  remarkDropDown_Added = (term) => ({ remarkId: term, name: term });
  senderDropDown_Added = (term) => ({ senderId: term, name: term });
  //DropDown Functions//

  checkboxChanged(event, obj, status, allSelectedList, type) {
    debugger;
    if (type == "mobile") {
      if (status == "selectAll") {
        if (event.target.checked) {
          var i = 1;
          allSelectedList.forEach(element => {
            this.selectedMailList.push(element.appEmailId);
            $('#checkboxm' + i).prop("checked", true);
            i++;
          })
        } else {

          var i = 1;

          allSelectedList.forEach(element => {
            this.selectedMailList.splice(this.selectedMailList.indexOf(element.appEmailId, 1));

            $('#checkboxm' + i).prop("checked", false);
            i++;
          })
        }

      } else {

        if (event.target.checked) {
          this.selectedMailList.push(obj.appEmailId);
          if (this.selectedMailList.length == this.approvedGrid.length) {
            $('#selectAllm').prop("checked", true);
          }

        }
        else {
          $('#selectAllm').prop("checked", false);
          this.selectedMailList.splice(this.selectedMailList.indexOf(obj.appEmailId), 1);
        }
      }
      this.selectedMailList = Array.from(new Set(this.selectedMailList));

      if (this.selectedMailList.length > 0) {
        this.showActions = true;
        if (this.checkClickCount == 0) {
          this.checkClickCount = 1;
          this.approvedObjActionShow = obj;
        }
      }
      else {
        this.checkClickCount = 0;
        this.approvedObjActionShow = null;
        this.showActions = false;
      }
    } else {
      if (status == "selectAll") {
        if (event.target.checked) {
          var i = 1;
          allSelectedList.forEach(element => {
            this.selectedMailList.push(element.appEmailId);
            $('#checkbox' + i).prop("checked", true);
            i++;
          })
        } else {

          var i = 1;

          allSelectedList.forEach(element => {
            this.selectedMailList.splice(this.selectedMailList.indexOf(element.appEmailId, 1));

            $('#checkbox' + i).prop("checked", false);
            i++;
          })
        }

      } else {

        if (event.target.checked) {
          this.selectedMailList.push(obj.appEmailId);
          if (this.selectedMailList.length == this.approvedGrid.length) {
            $('#selectAll').prop("checked", true);
          }

        }
        else {
          $('#selectAll').prop("checked", false);
          this.selectedMailList.splice(this.selectedMailList.indexOf(obj.appEmailId), 1);
        }
      }
      this.selectedMailList = Array.from(new Set(this.selectedMailList));

      if (this.selectedMailList.length > 0) {
        this.showActions = true;
        if (this.checkClickCount == 0) {
          this.checkClickCount = 1;
          this.approvedObjActionShow = obj;
        }
      }
      else {
        this.checkClickCount = 0;
        this.approvedObjActionShow = null;
        this.showActions = false;
      }
    }

  }

  StarClick(appEmailId, star,status) {
    debugger;
    this._approvedService.starUnstar(appEmailId, star)
      .subscribe((response) => {
        // console.log(response);
       
          if (star==1) {
            info_noti('Starred Success...');
          } else {
            info_noti('UnStarred Success...');
          }
        this.GetApproved_Grid();
      })
  }

  HideClick(appEmailId, hide, status) {
    if (status == 'ViewModal') {
      $("#ViewModal").modal("hide");
      $("body").removeClass('modal-open');
      $('.modal-backdrop').remove();
    }

    this._approvedService.hideUnhide(appEmailId, hide)
      .subscribe((response) => {
        info_noti('Hidden Success...');
        //  info_noti("Hidden Success...");
        this.GetApproved_Grid();
      })
  }

  //Delete
  DeleteApproved(id: any, status) {

    debugger;
    if (status == 'ViewModal') {
      $("#ViewModal").modal("hide");
      $("body").removeClass('modal-open');
      $('.modal-backdrop').remove();
    }
    this._approvedService.Delete_HealthCard(id)
      .subscribe((response) => {
        debugger;
        info_noti('Deleted Success...');
        //  info_noti('Deleted Success...');
        this.GetApproved_Grid();
      });
  }

  //multiple delete
  multipleDelete() {
    debugger;
    for (var i = 0; i < this.selectedMailList.length; i++) {
      this.appvar = new Approved();
      this.appvar.appEmailId = Number(this.selectedMailList[i]);
      this.selectedActionList[i] = this.appvar;
    }
    this._approvedService.deleteMultiple(this.selectedActionList).subscribe((response) => {
      info_noti('Deleted Success...');
      this.selectedMailList.length = 0;
      this.appvar
      this.selectedActionList.length = 0;
      if (this.selectedMailList.length > 0) {
        this.showActions = true;
      }
      else {
        this.approvedObjActionShow = null;
        this.checkClickCount = 0;
        this.showActions = false;
      }
      $('#selectAll').prop("checked", false);
      $('#selectAllm').prop("checked", false);
      this.GetApproved_Grid();
    }, error => { info_noti(error); }
    );
    console.log(this.selectedMailList);
  }


  multipleStar(flag: boolean) {
    debugger;

    for (var i = 0; i < this.selectedMailList.length; i++) {
      this.appvar = new Approved();
      this.appvar.appEmailId = Number(this.selectedMailList[i]);
      this.appvar.star = true;

      this.selectedActionList[i] = this.appvar;
    }
    this._approvedService.starMultiple(this.selectedActionList).subscribe((response) => {
      info_noti('Starred Success...');
      //  info_noti("Starred Success...");
      this.selectedMailList.length = 0;

      this.selectedActionList.length = 0;
      if (this.selectedMailList.length > 0) {
        this.showActions = flag;
      }
      else {
        this.approvedObjActionShow = null;
        this.showActions = false;
        this.checkClickCount = 0;
      }
      $('#selectAll').prop("checked", false);
      $('#selectAllm').prop("checked", false);
      this.GetApproved_Grid();
    }, error => { info_noti(error); }
    );


    console.log(this.selectedMailList);

  }
  multipleEye(flag: boolean) {
    debugger;
    for (var i = 0; i < this.selectedMailList.length; i++) {
      this.appvar = new Approved();
      this.appvar.appEmailId = Number(this.selectedMailList[i]);
      this.appvar.hide = flag;
      this.selectedActionList[i] = this.appvar;
    }
    this._approvedService.hideMultiple(this.selectedActionList).subscribe((response) => {
      info_noti('Hidden Success...');
      this.selectedMailList.length = 0;
      this.appvar
      this.selectedActionList.length = 0;
      if (this.selectedMailList.length > 0) {
        this.showActions = true;
      }
      else {
        this.approvedObjActionShow = null;
        this.showActions = false;
        this.checkClickCount = 0;
      }
      $('#selectAll').prop("checked", false);
      $('#selectAllm').prop("checked", false);
      this.GetApproved_Grid();
    }, error => { info_noti(error); }
    );
    console.log(this.selectedMailList);

  }

  enteredEmailIDForForwordEmail(emailId) {
    this.emailId = emailId;
  }
  multipleForword(emailId,form:NgForm) {
    if (emailId != "") {
      $("#multipleForwordBtn").attr("disabled", true);
      for (var i = 0; i < this.selectedMailList.length; i++) {
        this.appvar = new Approved();
        this.appvar.appEmailId = Number(this.selectedMailList[i]);
        this.selectedActionList[i] = this.appvar;
      }
      
      this.sendEmailmultiple.approved = this.selectedActionList;
      // this.sendEmailmultiple.emailid = emailId;
      
      this.sendEmailmultiple.emailid = this.sendEmailForm.controls['toAddress'].value;
      
    
      this._approvedService.forwordMultiple(this.sendEmailmultiple).subscribe((response) => {
        info_noti("Email Send Success...");
        $("#multipleForwordBtn").attr("disabled", false);
        $('#sendForwordemail').val('');
        $("#sendEmailForMultipleForword").modal("hide");
        $("body").removeClass('modal-open');
        $('.modal-backdrop').remove();
        this.selectedMailList.length = 0;
        
        this.selectedActionList.length = 0;
        if (this.selectedMailList.length > 0) {
          this.showActions = true;
        }
        else {
          this.approvedObjActionShow = null;
          this.showActions = false;
          this.checkClickCount = 0;
          this.sendEmailmultiple = new sendEmailmultiple;
        }
        $('#selectAll').prop("checked", false);
        $('#selectAllm').prop("checked", false);
        this.GetApproved_Grid();
       
      
      }, error => {
        info_noti("Email Not send");
       
        $("#sendEmailForMultipleForword").modal("hide");
        $("body").removeClass('modal-open');
        $('.modal-backdrop').remove();
      }
      );
      console.log(this.selectedMailList);
    } else {
      this.emailId = '';
      console.log(this.emailId);
    }


  }

  onFileChange(event) {
    this.selectedFileNames.nativeElement.innerHTML = '';
    this.selectedFiles = event.target.files;
    console.log(event.target.files);
    if (this.selectedFiles.length > 0) {
      this.uploadfile = true;
      for (let i = 0; i < this.selectedFiles.length; i++) {
        this.selectedFileNames.nativeElement.innerHTML += this.selectedFiles[i].name + "<br/>";
      }
      this.uploadService.uploadfile(this.selectedFiles, "");
    }

    //  this.uploadService.SaveAttchment().subscribe((response)=>{
    // var attchment=response;
    // console.log(attchment);

    //  });
  }


 
  sendEmailForm: FormGroup;
  loadSendEmailForm(){
      this.sendEmailForm = this.fb.group({
        'toAddress': ['', [Validators.required, this.commaSepEmail]]
      });
    }
  
    send(value) {
      console.log(value);
    }
  
    commaSepEmail = (control: AbstractControl): { [key: string]: any } | null => {
      const emails = control.value.split(',');
      const forbidden = emails.some(email => Validators.email(new FormControl(email)));
      console.log(forbidden);
      return forbidden ? { 'toAddress': { value: control.value } } : null;
    };

  AttachmentShow_DataBind(data) {
    this.approvedAttachmentDataShow = data;

  }
  Attachment_DataBind(data: any) {
    this.approvedAttachmentData = data;
  }
  sendMailClose(form:NgForm) {
    $('#sendForwordemail').val('');
    this.emailId = "";
 
  }
  updateUsingViewModel(id) {
    $("#ViewModal").modal("hide");
    $("body").removeClass('modal-open');
    $('.modal-backdrop').remove();

    this.router.navigate(['/dashboard/updatehc/' + id + '/approved']);
  }
  sendForwordEmailOpen() {
    this.loadSendEmailForm();
    $('#sendForwordemail').focus();

  }


  forwordEmailEnter(sendForwordemail,form:NgForm) {
    $('#multipleForwordBtn').focus();
    this.multipleForword(sendForwordemail,form);
  }

  senderIdEnter() {
    this.subjectId.focus();
  }
  subjectEnter() {
    $('#body').focus();
  }
  bodyEnter() {
    $('#date_time').focus();
  }
  dateEnter() {
    this.specificationId.focus();

  }
  spcificationEnter() {
    $('#amount').focus();
  }
  amountEnter() {
    this.remarkId.focus();

  }
  remarkEnter() {
    $('#eyeIcon').focus();
  }
  eyeEnter() {
    $('#starIcon').focus();
  }
  starEnter() {
    $('#saveBtn').focus();
  }



  // define the JSON of data
  //  public gameList: { [key: string]: Object }[] = [
  //   { Id: 'Game1', Game: 'American Football' },
  //   { Id: 'Game2', Game: 'Badminton' },
  //   { Id: 'Game3', Game: 'Basketball' },
  //   { Id: 'Game4', Game: 'Cricket' },
  //   { Id: 'Game5', Game: 'Football' },
  //   { Id: 'Game6', Game: 'Golf' },
  //   { Id: 'Game7', Game: 'Hockey' },
  //   { Id: 'Game8', Game: 'Rugby' },
  //   { Id: 'Game9', Game: 'Snooker' },
  //   { Id: 'Game10', Game: 'Tennis' },
  // ];
  // map the appropriate columns to fields property
  // public fields1: object = {text: 'name', value: 'specificationId'};
  // // set the placeholder to MultiSelect input element
  // public waterMark: string = 'Select specification or add custom specification';
  // // set the type of mode for how to visualized the selected items in input element.
  // public box : string = 'Box';



  //browser back button or mobile back button
  @HostListener('window:popstate', ['$event'])
  onPopState(event) {

    $("#AddApprovedModal").modal("hide");
    $("body").removeClass('modal-open');
    $('.modal-backdrop').remove();

    $("#ViewModal").modal("hide");
    $("body").removeClass('modal-open');
    $('.modal-backdrop').remove();

    $("#HideModal").modal("hide");
    $("body").removeClass('modal-open');
    $('.modal-backdrop').remove();

    $("#AttachmentModal").modal("hide");
    $("body").removeClass('modal-open');
    $('.modal-backdrop').remove();

    $("#attchmentShowModal").modal("hide");
    $("body").removeClass('modal-open');
    $('.modal-backdrop').remove();

    $("#sendEmailForMultipleForword").modal("hide");
    $("body").removeClass('modal-open');
    $('.modal-backdrop').remove();

  }
  getSenderName() {
    this._approvedService.GetSenderName().subscribe(res => {
      this.senderNameDropDown = res;
      // Object.assign(this.senderNameDropDown, res);

      console.log("Sender Name:" + this.senderNameDropDown)
    }, err => {
      info_noti("Error To get Sender Name")
    })

  }
  downloadFile(path) {
    window.open(path, '_self');
  }

  Eye_ClickViewData(appEmailId) {
    debugger
    
    if (this.eyeIconViewData == "zmdi-eye") {
      this.eyeIconViewData = "zmdi-eye-off";
      this.HideClick(appEmailId, 0, '');
    } else {
      this.eyeIconViewData ="zmdi-eye";
      this.HideClick(appEmailId, 1, 'ViewModal');
    }
  

  }
  Star_ClickViewData(appEmailId) {
    debugger
    
    if (this.starIconViewData == "zmdi-star") {
      this.starIconViewData = "zmdi-star-outline";
      this.StarClick(appEmailId, 0,'viewData');
    } else {
      this.starIconViewData = "zmdi-star";
      this.StarClick(appEmailId, 1,'viewData');
    }
   

  }


  // printHTMLDiv() {
  //   var contents = $("#printdiv").html();
  //   var frame1 = $('<iframe />');
  //   frame1[0].name = "frame1";
  //   frame1.css({ "position": "absolute", "top": "-1000000px" });
  //   $("body").append(frame1);
  //   var frameDoc = frame1[0].contentWindow ? frame1[0].contentWindow : frame1[0].contentDocument.document ? frame1[0].contentDocument.document : frame1[0].contentDocument;
  //   frameDoc.document.open();
  //   //Create a new HTML document.
  //   frameDoc.document.write('<html><head><title>DIV Contents</title>');
  //   frameDoc.document.write('</head><body>');
  //   //Append the external CSS file.
  //   frameDoc.document.write('<link href="assets/css/print.min.css" rel="stylesheet" type="text/css" />');
  //   //Append the DIV contents.
  //   frameDoc.document.write(contents);
  //   frameDoc.document.write('</body></html>');
  //   frameDoc.document.close();
  //   setTimeout(function () {
  //       window.frames["frame1"].focus();
  //       window.frames["frame1"].print();
  //       frame1.remove();
  //   }, 500);

  // }

//send Email 



}
